// Assembles the guided backdrop answers into a single, vivid scene prompt.
// Final polish happens server-side via assist-vision-prompt.

export interface BackdropAnswers {
  affirmation: string;
  scene: string;        // "Where are you?"
  people?: string;      // "Who is with you?" (optional)
  doing?: string;       // "What are you doing?"
  mood?: string;        // "Mood, light, time of day"
}

export function buildBackdropPrompt(a: BackdropAnswers): string {
  const parts: string[] = [];
  parts.push(
    `A cinematic, photorealistic moment that captures the reality where this affirmation is already true: "${a.affirmation.trim()}".`
  );
  if (a.scene?.trim()) parts.push(`Setting: ${a.scene.trim()}.`);
  if (a.doing?.trim()) parts.push(`Action: ${a.doing.trim()}.`);
  if (a.people?.trim()) parts.push(`People present: ${a.people.trim()}.`);
  if (a.mood?.trim()) parts.push(`Mood and light: ${a.mood.trim()}.`);
  parts.push(
    "Inspiring, aspirational, emotionally resonant. Soft cinematic lighting, shallow depth of field where appropriate, ultra-detailed, 16:9 composition suitable as an ambient backdrop."
  );
  return parts.join(" ");
}
